export const iconFontAwesomeChildhoodCubesStacked = (
	<i className="fa-solid fa-cubes-stacked"></i>
);
